<div class="container" dir="rtl">
  <div *ngIf="report?.CombustionScore">
    <ng-container *ngIf="report?.CombustionScore !== -1">
      <div class="report-card">
        <p class="report-text text-center">{{report?.ProblemCategory}}</p>
        <div class="score-section py-4">
          <div class="score-number">
            <small>100 /</small>
            {{ report?.CombustionScore }}
          </div>

          <div class="progress-track">
            <div class="progress-fill" [style.width.%]="report?.CombustionScore"></div>
          </div>

          <div class="text-center pt-4">
            <span
              class="status-badge"
              [ngClass]="{
                'good': report?.CombustionScore >= 70,
                'medium': report?.CombustionScore >= 40 && report?.CombustionScore < 70,
                'bad': report?.CombustionScore < 40
                }">
              {{ report?.CombustionLevel }}
            </span>
          </div>
        </div>

        <div class="report-section">
          <h3>گزارش تحلیل</h3>
          <div class="report-text">
            {{ report?.DiagnosticReport }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
